<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Layout from "@/router/layouts/main";
import { Helper } from "@/mixin/helper";
import { GET_VEHICLE_ID, GET_VEHICLE_AUDIT_LOG } from "@/services/api/master/fleet";

export default {
  page: {
    title: "Update History",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  apollo: {
    vehicle: {
      query: GET_VEHICLE_ID,
      variables() {
        return {
          filter: {
            id: parseInt(this.$route.params.id),
          },
        };
      },
      // Disable the query
      skip() {
        return !this.$route.params.id;
      },
      result({ data, loading }) {
        if (!loading && !data.vehicle.isSuccessful) {
          this.$toast.warning(data.vehicle.message);
        }
        this.licensePlate = data.vehicle.vehicle.licensePlate;
      },
    },
    vehicleAuditLogs: {
      query: GET_VEHICLE_AUDIT_LOG,
      variables() {
        return {
          filter: {
            vehicleId: parseInt(this.$route.params.id),
          }
        };
      },
      result({ data, loading }) {
        if (loading) return;
        this.totalRows = data.vehicleAuditLogs.vehicleAuditLogs.length;
        this.filteredItems = data.vehicleAuditLogs.vehicleAuditLogs;
      },
    }
  },
  mixins: [Helper],
  data() {
    return {
      vehicleAuditLogs: {
        vehicleAuditLogs: []
      },
      licensePlate: '',
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      filteredItems: [],
      fields: [
        {
          key: "time",
          label: "Waktu",
          sortable: true,
        },
        {
          key: "action",
          label: "Deskripsi Perubahan",
          sortable: true,
        },
        {
          key: "detail",
          label: "Informasi",
          sortable: true,
        },
        {
          key: "user",
          label: "Pengubah",
          sortable: true,
        },
      ],
    };
  },
  computed: {
    title() {
      // return this.$t("setting.list.userSetting.pengaturanPengguna");
      return this.$t("Riwayat Perubahan");
    },
    rows() {
      return this.vehicleAuditLogs.vehicleAuditLogs.length;
    },
  },
  mounted() {
    this.$apollo.queries.vehicle.refetch();
    this.$apollo.queries.vehicleAuditLogs.refetch();
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems;
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>
<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />
      <p class="mb-4">Menampilkan semua catatan aktivitas dari {{ licensePlate }}</p>
      <div class="clearfix mc-btn-group__list">
        <div class="float-end">
          <b-button @click="$router.push({ name: 'Master Fleet Update' })" variant="outline-primary" class="ms-3">
            <i class="mc-fa fa-large icon-outline_arrow-left"></i>
            {{ $t("global.back") }}
          </b-button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-12 col-md-12 d-flex flex-row-reverse mc-table-view-wrapper">
            <div class="mc-table-view">
              <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                <label class="d-inline-flex align-items-center mc-table-view__search">
                  <i class="mc-fa fas fa-search"></i>
                  <b-form-input v-model="filter" type="search" :placeholder="$t('global.search') + '...'"
                    class="ms-2"></b-form-input>
                </label>
              </div>
            </div>
          </div>
        </div>
        <!-- Table -->
        <div class="table-responsive my-3 border border-1">
          <b-table small show-empty :items="vehicleAuditLogs.vehicleAuditLogs" :fields="fields" class="datatables"
            responsive="lg" sort-by="time" empty-table :empty-text="$t('global.emptyTable')"
            :empty-filtered-text="$t('global.emptyFilteredTable')" :per-page="perPage" :current-page="currentPage"
            :filter="filter" @filtered="onFiltered">
            <template #cell(time)="row">
              <div>
                <p class="font-weight-bold">
                  {{ momentDateShortMonth(row.value) }}
                </p>
                <p class="text-muted">{{ momentTime(row.value) }}</p>
              </div>
            </template>
          </b-table>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center">
                Menampilkan
                <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm" :options="pageOptions">
                </b-form-select>
                entri.
                <p>
                  Menampilkan&nbsp;<strong>{{
                      filteredItems.length > 0
                        ? (currentPage - 1) * perPage + 1
                        : 0
                  }}</strong>&nbsp;sampai&nbsp;<strong>{{
    Math.min(filteredItems.length, currentPage * perPage)
}}</strong>&nbsp;dari&nbsp;<strong>{{ filteredItems.length }}</strong>&nbsp;entri.
                </p>
              </label>
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination v-model="currentPage" :total-rows="totalRows == null ? rows : totalRows"
                  :per-page="perPage"></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
